import type { ToastView } from "./view-model";

export interface ToastsProps {
  toasts: ToastView[];
  onDismissToast(id: number): void;
}

export function Toasts({ toasts, onDismissToast }: ToastsProps) {
  const latest = toasts.length > 0 ? toasts[toasts.length - 1] : null;
  if (!latest) {
    return <div className="toast" id="toast" role="status" aria-live="polite" hidden />;
  }

  return (
    <div
      className="toast on"
      id="toast"
      data-testid="toast"
      role="status"
      aria-live="polite"
      onClick={(e) => {
        e.stopPropagation();
        onDismissToast(latest.id);
      }}
    >
      {latest.text}
    </div>
  );
}
